import { useCallback } from "react";
import type { CcofCardOnFile } from "lib/api-types/schemas";
import { useUpdatePatientCardCache } from "./useUpdatePatientCardCache";

export function useUpdateCardOnFileCache(patientId: string) {
  const updatePatientCardCache = useUpdatePatientCardCache(patientId);

  return useCallback(
    (card: CcofCardOnFile) => {
      const cardOnFile = {
        cardHolderName: card.cardHolderName!,
        brand: card.brand!,
        last4: card.last4!,
        expMonth: card.expMonth!,
        expYear: card.expYear!,
      };
      updatePatientCardCache({ cardOnFile });
    },
    [updatePatientCardCache],
  );
}
